<template>
  <div class="white-box mm15 p30 mb-3" style="min-height: auto;">
    <div class="overlay" :class="{ 'overlayshow': modal.overlay }"></div>

    <div class="popup-item p-0">
      <div class="row gap-2">
        <div class="col-sm-12">
          <div class="grey">Status</div>
          <div class="status mt-1" :style="`background-color: #0044F41a;color: #0044F4;text-transform: Capitalize;`">
            {{ statusLabel }}
          </div>
        </div>

        <!-- ========================================== -->
        <!-- internal issue -->
        <!-- ========================================== -->
        <div
          v-if="['Outstanding Internal - Waiting Close Investigation Internal Issue', 'Closed'].includes(statusLabel) && customerIssue">
          <div class="col-sm-12">
            <div class="box_bordered mb-2">
              <div class="box_bordered__header">
                <img :src="IconCheck" alt="check">
                <div class="font-500 ft-14">Close Investigation Customer Issue - {{ moment(customerIssue?.date_result,
                  'YYYY-MM-DD').format('DD MMMM YYYY') }}</div>
              </div>
              <div class="col-sm-12">
                <div class="grey">Result</div>
                <div style="word-wrap: break-word;">{{ customerIssue?.result }}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="['Outstanding Internal - Waiting For Verification Tech Mkt Supp Manager', 'Outstanding Internal - Cancel', 'Closed', 'Outstanding Internal & Customer - Waiting For Verification Tech Mkt Supp Manager'].includes(statusLabel) && internalIssue">
          <div class="col-sm-12">
            <div class="box_bordered mb-2">
              <div class="box_bordered__header">
                <img :src="IconCheck" alt="check">
                <div class="font-500 ft-14">Close Investigation Internal Issue - {{ moment(internalIssue?.date_result,
                  'YYYY-MM-DD').format('DD MMMM YYYY') }}</div>
              </div>
              <div class="col-sm-12">
                <div class="grey">Result</div>
                <div style="word-wrap: break-word;">{{ internalIssue?.result }}</div>
              </div>
            </div>
            <div v-if="['Outstanding Internal - Cancel'].includes(statusLabel)" class="popup-item p-0">
              <div class="row">
                <div class="col-sm-12">
                  <div class="d-flex flex-row  align-items-center gap-2">
                    <div style="border-radius: 100%; width: 7px; height: 7px; background-color: #F4AF00;"></div>
                    <div class="ft-12">Cancel From - <strong>Tech Mkt Supp Manager</strong></div>
                  </div>
                  <div class="p-3 my-3 rounded"
                    style="border-top-left-radius: 0 !important; background-color: #E9EAF3; color: #292865;">
                    {{ internalIssue?.revisions[internalIssue?.revisions.length - 1]?.revision }}
                  </div>
                </div>
                <div class="col-sm-12">
                  <button @click="openModal('closeInternalIssue')" class="btn btn-orange w-100">Edit</button>
                </div>
              </div>
            </div>
            <div
              v-if="['Outstanding Internal - Waiting For Verification Tech Mkt Supp Manager', 'Outstanding Internal & Customer - Waiting For Verification Tech Mkt Supp Manager'].includes(statusLabel)"
              class="row gx-4">
              <div v-permissions="'Cancel Feedback and Complaint Internal Issue'" class="col-sm-6">
                <button @click="openModal('cancelInternalIssue')" class="btn btn-border-orange w-100">Cancel</button>
              </div>
              <div v-permissions="'Close Feedback and Complaint Internal Issue'" class="col-sm-6">
                <!-- Call onClose function on close modal -->
                <button @click="$refs.cancelInternalIssue.onClose(statusLabel)"
                  class="btn btn-orange w-100">Approve</button>
              </div>
            </div>
          </div>
        </div>


        <div class="col-sm-12">
          <button v-permissions="'Request Close Feedback and Complaint Internal Issue'"
            v-if="['Outstanding Internal', 'Outstanding Internal - Waiting Close Investigation Internal Issue'].includes(statusLabel)"
            @click="openModal('closeInternalIssue')" class="btn btn-orange mm15 w-100">Close Investigation
            Internal Issue</button>
          <button v-permissions="'Request Close Feedback and Complaint Internal Issue,Request Close Feedback and Complaint Customer Issue'" v-if="statusLabel === 'Outstanding Internal & Customer'"
            @click="openModal('cancelBothInternalCustomer')" class="btn btn-orange mm15 w-100">Close Feedback &
            Complaint</button>
        </div>
      </div>


      <div class="popup-wrapper" :class="{ 'showing': modal.cancelBothInternalCustomer }">
        <div class="popup-card p25">
          <div class="d-flex justify-content-between align-items-center">
            <div class="font-bold">Close Feedback & Complaint</div>
            <button @click="closeModal('cancelBothInternalCustomer')" class="btn btn-for-close"><span
                class="icon-ico-close"></span></button>
          </div>
          <div class="inner-land">
            <div class="my-2">Do you want to close?</div>
            <div class="popup-item">
              <div class="row gap-3">
                <div class="col-sm-12">
                  <button v-permissions="'Request Close Feedback and Complaint Customer Issue'" @click="closeModal('cancelBothInternalCustomer'); openModal('closeCustomerIssue')"
                    class="btn btn-border-orange mm15 w-100">Close
                    Investigation Customer Issue</button>
                </div>
                <div class="col-sm-12">
                  <button v-permissions="'Request Close Feedback and Complaint Internal Issue'" @click="closeModal('cancelBothInternalCustomer'); openModal('closeInternalIssue')"
                    class="btn btn-border-orange mm15 w-100">Close
                    Investigation Internal Issue</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Detail Modal: Close Internal Issue -->
      <CloseInternalIssue :modal="modal.closeInternalIssue" @close-modal="closeModal('closeInternalIssue')"
        :statusLabel="statusLabel" />

      <!-- Detail Modal: Close customer Issue -->
      <CloseCustomerIssue :modal="modal.closeCustomerIssue" @close-modal="closeModal('closeCustomerIssue')"
        :statusLabel="statusLabel" />

      <!-- Detail Modal: Cancel Internal Issue -->
      <CancelInternalIssue ref="cancelInternalIssue" :modal="modal.cancelInternalIssue"
        @close-modal="closeModal('cancelInternalIssue')" />

      <!-- Detail Modal: Cancel Customer Issue -->
      <CancelCustomerIssue ref="cancelCustomerIssue" :modal="modal.cancelCustomerIssue"
        @close-modal="closeModal('cancelCustomerIssue')" />

    </div>
  </div>
</template>

<script>
import CloseInternalIssue from './CloseInternalIssue.vue'
import CloseCustomerIssue from './CloseCustomerIssue.vue'
import CancelInternalIssue from './CancelInternalIssue.vue'
import CancelCustomerIssue from './CancelCustomerIssue.vue'

import IconCheck from '@/assets/icons/check.svg';
import moment from 'moment'

export default {
  name: 'DetailStatus',
  components: {
    CloseInternalIssue,
    CloseCustomerIssue,
    CancelInternalIssue,
    CancelCustomerIssue
  },
  data() {
    return {
      modal: {
        closeInternalIssue: false,
        closeCustomerIssue: false,
        cancelInternalIssue: false,
        cancelCustomerIssue: false,
        cancelBothInternalCustomer: false,
        overlay: false
      },
      IconCheck,
      moment
    }
  },
  computed: {
    statusValue() {
      return this.detail?.status?.value
    },
    statusLabel() {
      return this.detail?.status?.label
    },
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
    internalIssue() {
      return this.$store.state?.feedbackComplaint?.internalIssue
    },
    customerIssue() {
      return this.$store.state?.feedbackComplaint?.customerIssue
    },
  },
  methods: {
    openModal(type) {
      this.modal[type] = true
      this.modal.overlay = true
    },
    closeModal(type) {
      this.modal[type] = false
      this.modal.overlay = false
    },
  }
}
</script>

<style scoped>
.box_bordered {
  border: 1px solid #292865;
  border-radius: 4px;
  padding: 1rem;
}

.box_bordered__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.box_bordered__header img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(15%) saturate(3041%) hue-rotate(205deg) brightness(90%) contrast(102%);
}
</style>
